import common from "../common";
import Button from "./Button";

export default class GelButton extends Button {
    constructor(label, icon, pos, css)
    {
    	if(pos == null) pos = Button.POSITION_TOP_LEFT;
    	if(css == null) css = {width:'50px', height:'50px'};

        super(pos, css); //runs init

        this.backing = null;
        this.icon = null;

        this.graphicDown = null;
        this.graphicOut = null;
        this.graphicOver = null;

        this.addIcon(icon);
        this.initButton(label);
    }

    init()
    {
        this.htmlElement = $('<div style="position:absolute; cursor: pointer;"></div>');
        this.htmlElement.css(this.constructPos);
        this.htmlElement.css(this.constructCss);
    }

    addIcon(icon)
    {
        this.icon = $('<img src="' + icon + '" class="p3-gelButton-image" />');
        this.htmlElement.append(this.icon);
    }

    setIcon(icon)
    {
        this.icon.attr('src', icon);
    }

    onMouseDown(e)
    {
        if(this.graphicDown)
        {
            this.backing.attr('src', this.graphicDown);
        }
    	super.onMouseDown(e);
    }

    onMouseUp(e)
    {
        if(this.graphicOut)
        {
            this.backing.attr('src', this.graphicOut);
        }
    	super.onMouseUp(e);
    }

    onMouseOver(e)
    {
        if(this.graphicOver)
        {
            this.backing.attr('src', this.graphicOver);
        }
    	super.onMouseOver(e);
    }

    onMouseOut(e)
    {
        if(this.graphicOut)
        {
            this.backing.attr('src', this.graphicOut);
        }
    	super.onMouseOut(e);
    }
}